/**
 * /app/beneficiaries/ownership — tenant-wide entry into the BO chart.
 *
 * Replaced the legacy fixture redirect (hardcoded 'vandermerwe-family-trust').
 * Routes to /app/trusts/$id/beneficial-ownership (the TPCA-tagged register).
 */

import { createFileRoute } from '@tanstack/react-router';
import { TrustScopedLanding } from '../../../components/screens/trust-scoped-landing';

export const Route = createFileRoute('/app/beneficiaries/ownership')({
  component: () => (
    <TrustScopedLanding
      suffix="beneficial-ownership"
      eyebrow="Beneficial ownership"
      title="Beneficial ownership"
      emptyHelp="The beneficial-ownership chart shows the TPCA s1 classification of every founder, trustee, beneficiary, and protector of your trust. It appears here once a trust is onboarded."
    />
  ),
});
